import { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import Fuse from 'fuse.js';
import { Item } from '../../api/fetchPastVitalsByPtOid';
import { hideDialog } from '../../store/actions/prescriptionPad';
import { GlobalState } from '../../store/reducers';
import { getPtPastVitals } from '../../store/selectors/prescriptionPad';
import RightPopUp from '../common/RightPopUp';
import { LabVitalEmptyCard } from './rightPanel/workspace/LabVitalHistoricalEmptyCard';
import LabVitalCardHeaderActions from './rightPanel/workspace/LabVitalCardHeaderActions';
import { ThunkDispatch } from 'redux-thunk';
import { Actions } from '../../store/actions';
import { HistoricalLabVitalsContent, sortKeyvitalsPastVisits } from './HistoricalLabVitalsContent';
import { PastVisitSearchBar } from './PastVisitSearchBar';
import LabVitalsHistoricalTable from './LabVitalsTable';
import { FETCH_STATE } from '../common/PatientOverviewUtils';

const fuseConfig = {
    keys: ['name'],
    threshold: 0.2,
};

type LabVitalsHistoricalTableCommonsProps = {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    ptPastVitals?: Item[];
    keyVitals?: string[];
    toggleKeyVitals?: (vitalId: string) => Promise<void>;
    patientId: string;
    fetchState?: FETCH_STATE;
    onRefresh?: () => void;
};
type LabVitalsHistoricalTableCommonsState = {
    vitalSearch: string;
};
class LabVitalsHistoricalTableCommons extends PureComponent<
    LabVitalsHistoricalTableCommonsProps,
    LabVitalsHistoricalTableCommonsState
> {
    fuse = new Fuse([] as Item[], fuseConfig);
    constructor(props: LabVitalsHistoricalTableCommonsProps) {
        super(props);
        this.state = {
            vitalSearch: '',
        };
        this.fuse = new Fuse(this.props.ptPastVitals || [], fuseConfig);
    }

    componentDidUpdate = (prevProps: LabVitalsHistoricalTableCommonsProps): void => {
        if (prevProps.ptPastVitals?.length !== this.props.ptPastVitals?.length) {
            this.fuse = new Fuse(this.props.ptPastVitals || [], fuseConfig);
        }
    };

    closeMe = () => {
        const { dispatch } = this.props;
        dispatch(hideDialog('longitudinal-vital-view'));
    };

    setSearchInput = (input: string) => {
        this.setState({ vitalSearch: input });
    };

    getColumnCount = () => {
        const { ptPastVitals } = this.props;
        return (ptPastVitals || []).reduce((max, item) => Math.max(max, item.values.length), 0);
    };

    getSearchResult = () => {
        const { vitalSearch } = this.state;
        const { ptPastVitals } = this.props;
        return vitalSearch ? this.fuse.search(vitalSearch).map((t) => t.item) : ptPastVitals || [];
    };
}

class LabVitalsRightPopUpComponent extends LabVitalsHistoricalTableCommons {
    constructor(props: LabVitalsHistoricalTableCommonsProps) {
        super(props);
    }

    render() {
        const { patientId } = this.props;
        const { vitalSearch } = this.state;
        const fData = this.getSearchResult();
        const maxCount = this.getColumnCount();

        const sortedFData =
            this.props.keyVitals && this.props.keyVitals.length !== 0
                ? sortKeyvitalsPastVisits(fData, this.props.keyVitals)
                : fData;

        return (
            <RightPopUp closeMe={this.closeMe}>
                <HistoricalLabVitalsContent
                    closeMe={this.closeMe}
                    fData={sortedFData}
                    maxCount={maxCount}
                    setSearchInput={this.setSearchInput}
                    vitalSearch={vitalSearch}
                    keyVitals={this.props.keyVitals}
                    toggleKeyVital={this.props.toggleKeyVitals}
                    patientId={patientId}
                />
            </RightPopUp>
        );
    }
}

export const LabVitalsRightPopUp = connect((state: GlobalState) => {
    const data = getPtPastVitals(state) || {};
    return {
        ptPastVitals: Object.keys(data).map((id) => ({
            id,
            ...data[id],
        })),
    };
})(LabVitalsRightPopUpComponent);

class PatientOverviewLabVitalsComponent extends LabVitalsHistoricalTableCommons {
    constructor(props: LabVitalsHistoricalTableCommonsProps) {
        super(props);
    }

    render() {
        const { ptPastVitals, patientId, fetchState, onRefresh } = this.props;

        if (!ptPastVitals || Object.keys(ptPastVitals).length <= 0) {
            return <LabVitalEmptyCard fetchState={fetchState} onRefresh={onRefresh} />;
        }

        const { vitalSearch } = this.state;
        const fData = this.getSearchResult();
        const maxCount = this.getColumnCount();

        return (
            <Fragment>
                <div className="sticky z-10 flex justify-between top-0 flex items-center px-16 py-6 space-x-8 border-b border-neutral-8 bg-white">
                    <div className="flex items-center">
                        <div className="flex justify-center items-center w-24 h-24 rounded-4 bg-darwin-accent-bright-yellow-800">
                            <svg
                                className="w-12 h-12 fill-white"
                                viewBox="0 0 14 13"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M12.7656 4.48438L9.01562 0.734375C8.875 0.59375 8.6875 0.5 8.5 0.5C8.28906 0.5 8.10156 0.59375 7.96094 0.734375C7.65625 1.01562 7.65625 1.50781 7.96094 1.78906L8.125 1.95312L1.75 8.30469C0.859375 9.21875 0.695312 10.6953 1.53906 11.6797C2.03125 12.2188 2.6875 12.5 3.36719 12.5C4 12.5 4.60938 12.2891 5.07812 11.7969L11.5469 5.375L11.7109 5.53906C11.8516 5.67969 12.0391 5.75 12.25 5.75C12.4375 5.75 12.625 5.67969 12.7656 5.53906C13.0703 5.25781 13.0703 4.76562 12.7656 4.48438ZM8.26562 6.5H5.6875L9.17969 3.00781L10.4688 4.32031L8.26562 6.5Z"></path>
                            </svg>
                        </div>
                        <p className="font-700 mx-8">Lab Results</p>
                        <div className="flex items-center space-x-8 bg-white border border-darwin-neutral-100 px-8 py-6 rounded-4 w-200">
                            <PastVisitSearchBar
                                input={vitalSearch}
                                setInput={this.setSearchInput}
                            />
                        </div>
                    </div>
                    <LabVitalCardHeaderActions />
                </div>
                <div className="space-y-16 bg-white overflow-hidden flex flex-col p-16">
                    <LabVitalsHistoricalTable
                        fData={fData}
                        columnCount={maxCount}
                        customColumnWidth={[250, 150]}
                        patientId={patientId}
                    />
                </div>
            </Fragment>
        );
    }
}

export default PatientOverviewLabVitalsComponent;
